<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-cog'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_product`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in tab" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="renderTabs(t.id)">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <itemList v-if="selectedTab === 'main'" ref="itemList" :class="{'active': selectedTab === 'main'}" class="tab-pane"></itemList>
            <sectionList v-if="selectedTab === 'section'" ref="itemSectionList" :class="{'active': selectedTab === 'section'}" class="tab-pane"></sectionList>
            <folderList v-if="selectedTab === 'folder'" ref="itemFolderList" :class="{'active': selectedTab === 'folder'}" class="tab-pane"></folderList>
            <itemSubCategoryList v-if="selectedTab === '123'" ref="itemSubCategoryList" :class="{'active': selectedTab === 'folder'}" class="tab-pane"></itemSubCategoryList>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import ItemList from './List'
import SectionList from './Section_List'
import FolderList from './Folder_List'
import ItemSubCategoryList from './SubCategoryList'
import {setSalonMenuTabLabel} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuItem',
    components:{
        BreadCrumb,
        
        ItemList,
        SectionList,
        FolderList,
        ItemSubCategoryList, 
    },
    data(){
        return{
            tab: [],
            selectedTab: 'main',
            // selectedTab: 'section',
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setTabLabel()
        }
    },
    methods:{
        renderTabs(id){
            this.selectedTab = id;
            // this.$refs.productList.addProductToggle = false;
            // this.$refs.productSubCategoryList.addSubToggle = false;
        },
        setTabLabel(){
            // this.tab = setSalonMenuTabLabel(this.$i18n.t('subMenu.salon_menu_product'), this.$i18n.t('header.subCategory', {'item': this.$i18n.t('subMenu.salon_menu_product')}))
            this.tab = [
                { id: 'main', text: 'Product' },
                { id: 'section', text: 'Section' },
                { id: 'folder', text: 'Folder' },
            ]
        }
    },
    mounted(){
        let $vm = this
        $vm.setTabLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>